import { getGlobalSessionInfo } from "../api";
import type { LogoutParams } from "../@types";
import { useCallback } from "react";
import { routes } from "../app/routes";
import { useHistoryCompat } from "./routing-hooks/useHistoryCompat";

export const getIsSlsxAuthenticated = async () => {
  const [res, error] = await getGlobalSessionInfo()
    .then(res => [res, null])
    .catch(error => [null, error]);
  return error || res === undefined ? false : true;
};

export const useLogout = () => {
  const history = useHistoryCompat();
  const logout = useCallback(
    ({ apiHasExpired, onLogout, sessionHasExpired }: LogoutParams) =>
      history.replace({
        pathname: routes.logout,
        state: {
          apiHasExpired,
          onLogout,
          sessionHasExpired,
        },
      }),
    [history]
  );
  return logout;
};
